<template>
  <span class="row my-2">
    <dt class="col-4">{{ title }}</dt>
    <dd class="col-8" v-if="value.length > 0" v-html="value"></dd>
    <dd class="col-8" v-else>N/A</dd>
  </span>
</template>
<script type="text/javascript">
export default {
  name: 'CustomerPolicyRow',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/CustomerPolicyRow.vue